import React, { useEffect, useState } from 'react';
import { catalogApi } from '../../api/catalog';

const COMPLEXITIES = ['LOW', 'MEDIUM', 'HIGH'];
const COMPLEXITY_LABELS = { LOW: 'Baja', MEDIUM: 'Media', HIGH: 'Alta' };

export default function CatalogAdmin() {
  const [catalog, setCatalog] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(null);

  useEffect(() => {
    loadCatalog();
  }, []);

  const loadCatalog = async () => {
    try {
      const response = await catalogApi.getPhases();
      setCatalog(response.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async (phaseId, hours, bufferPct) => {
    setSaving(phaseId);
    try {
      await catalogApi.updatePhase(phaseId, hours, bufferPct);
      loadCatalog();
    } catch (err) {
      alert('Error al actualizar');
    } finally {
      setSaving(null);
    }
  };

  if (loading) return <div className="flex justify-center py-12"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div></div>;

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-800">Catálogo de Fases SDLC</h1>
      <p className="text-sm text-gray-500">Configura las horas estándar por fase y nivel de complejidad.</p>

      {COMPLEXITIES.map((complexity) => (
        <div key={complexity} className="bg-white rounded-xl border border-gray-200 overflow-hidden">
          <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
            <h3 className="font-semibold text-gray-800">
              Complejidad {COMPLEXITY_LABELS[complexity]} ({complexity})
            </h3>
          </div>
          <table className="w-full text-sm">
            <thead className="border-b border-gray-100">
              <tr>
                <th className="px-4 py-2 text-left text-gray-600 font-medium">Fase</th>
                <th className="px-4 py-2 text-left text-gray-600 font-medium">Horas estándar</th>
                <th className="px-4 py-2 text-left text-gray-600 font-medium">Buffer %</th>
                <th className="px-4 py-2 text-left text-gray-600 font-medium">Total (con buffer)</th>
                <th className="px-4 py-2"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {Object.entries(catalog[complexity] || {}).map(([phaseName, data]) => (
                <PhaseRow
                  key={data.id}
                  phaseName={phaseName}
                  data={data}
                  saving={saving === data.id}
                  onSave={(hours, buffer) => handleUpdate(data.id, hours, buffer)}
                />
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}

function PhaseRow({ phaseName, data, saving, onSave }) {
  const [hours, setHours] = useState(data.hours);
  const [buffer, setBuffer] = useState(data.buffer_pct);
  const modified = hours !== data.hours || buffer !== data.buffer_pct;

  return (
    <tr className="hover:bg-gray-50">
      <td className="px-4 py-2 text-gray-700">{phaseName}</td>
      <td className="px-4 py-2">
        <input
          type="number"
          value={hours}
          onChange={(e) => setHours(parseFloat(e.target.value) || 0)}
          className="w-20 px-2 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 outline-none"
          step="0.5"
          min="0"
        />
      </td>
      <td className="px-4 py-2">
        <input
          type="number"
          value={buffer}
          onChange={(e) => setBuffer(parseFloat(e.target.value) || 0)}
          className="w-20 px-2 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 outline-none"
          step="1"
          min="0"
          max="100"
        />
      </td>
      <td className="px-4 py-2 text-gray-500">
        {(hours * (1 + buffer / 100)).toFixed(1)}h
      </td>
      <td className="px-4 py-2">
        {modified && (
          <button
            onClick={() => onSave(hours, buffer)}
            disabled={saving}
            className="px-3 py-1 bg-green-600 text-white rounded text-xs hover:bg-green-700 disabled:opacity-50"
          >
            {saving ? '...' : 'Guardar'}
          </button>
        )}
      </td>
    </tr>
  );
}
